import React, { useEffect } from 'react';
import { ArrowUpIcon } from '@chakra-ui/icons';
import { Helmet } from 'react-helmet';
import { Box } from '@chakra-ui/react';
import {
  Footer, Header, ReviewWidget, SEO,
} from '../_index';
import axios from 'axios';
import { useFormValue } from '../../context';

const SubmitOnExit = (data) => {
  return (window.onbeforeunload = function () {
    console.log('exist form data', data);
    (function () {
      axios
        .post('https://hooks.zapier.com/hooks/catch/6894175/b2jx6m3/', data)
        .then((res) => {
          console.log('form data submitted on page exist', res.status);
        })
        .catch((err) => {
          console.error(err);
        });
    }());
  });
};

const Layout = ({ children, location }) => {
  const { formStore } = useFormValue();
  // window.addEventListener('beforeunload', (e) => {
  //   console.log('leving page');

  //   return alert('you are leaving');
  // });
  if (typeof window !== 'undefined') {
    SubmitOnExit(formStore);
  }

  return (
    <>
      <Helmet>
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
        />
        <link
          rel="preconnect"
          href="https://fonts.googleapis.com"
        />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter&family=Manrope:wght@600;700&display=swap"
          rel="stylesheet"
        />
        <script
          async
          src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCeKzpRPS6Bry8yhRxo8M0ImeOt8b_R8nc&libraries=places"
        />
      </Helmet>

      <Box
        minHeight="100vh"
        overflow="hidden"
      >
        <Header
          zIndex={10}
          location={location}
        />
        <Box pt={20}>{children}</Box>
        <ReviewWidget />
      </Box>
      <Box
        pos="fixed"
        cursor="pointer"
        backgroundColor="white"
        opacity=".7"
        display="flex"
        justifyContent="center"
        alignItems="center"
        bottom="2rem"
        borderRadius="100%"
        right="2rem"
        width="50px"
        height="50px"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <ArrowUpIcon style={{ height: '2rem', width: '2rem' }} />
      </Box>
      <Footer location={location} />
    </>
  );
};

export default Layout;
